import { DailyVideo, useParticipantProperty } from '@daily-co/daily-react';
import { AnimatePresence, motion } from 'framer-motion';
import useParticipantsWithHost from '../../hooks/useParticipantsWithHost';
import './ModeratorBox.css';

/**
 * Componente para exibir o moderador acompanhando a sessão
 */
export default function ModeratorBox() {
  const { participantMod } = useParticipantsWithHost();

  // IMPORTANTE: Hook deve ser chamado ANTES de qualquer return condicional
  // Usa session_id do moderator ou null se não existir
  const moderatorName = useParticipantProperty(participantMod?.session_id, 'user_name') || 'Moderator';

  const isVisible = participantMod && participantMod.session_id;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          key={participantMod.session_id}
          className="moderator-box"
          initial={{ opacity: 0, x: -100, scale: 0.8 }}
          animate={{
            opacity: 1,
            x: 0,
            scale: 1,
            transition: {
              duration: 0.5,
              ease: [0.16, 1, 0.3, 1], // easeOutExpo
              x: {
                type: "spring",
                stiffness: 200,
                damping: 20
              },
              scale: {
                type: "spring",
                stiffness: 300,
                damping: 15
              }
            }
          }}
          exit={{
            opacity: 0,
            x: -100,
            scale: 0.8,
            transition: {
              duration: 0.3,
              ease: "easeIn"
            }
          }}
        >
          <div className="moderator-box-content">
            <div className="moderator-box-camera">
              <DailyVideo automirror sessionId={participantMod.session_id} type="video" />
            </div>
            <div className="moderator-box-text">
              Mod <span className="moderator-box-name">{moderatorName}</span> is following along
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

